import {
  Box,
  MenuItem,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { CasLoader } from "../brand/CasLoader";
import { useComponentSearch } from "../../hook/component";
import { UseMenuProps } from "../../hook/menu";
import { Component } from "../../types/component";

export const ComponentSelectMenu: React.FC<
  UseMenuProps & {
    onChange: (component: Component) => Promise<any>;
  }
> = ({ onChange, ...useMenuProps }) => {
  const { onClose, open } = useMenuProps;
  const { searchString, setIsLoading, isLoading, setSearchString, page } =
    useComponentSearch({ disabledSearch: !open });

  return (
    <Popover {...useMenuProps}>
      <Box sx={{ p: 2, width: "20rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Select Component</Typography>
          {isLoading && <CasLoader size={20} />}
        </Box>
        <TextField
          fullWidth
          value={searchString}
          onChange={(e) => setSearchString(e.currentTarget.value)}
          placeholder="Search components..."
          sx={{ mt: 2 }}
        />
        <Box sx={{ height: "10rem", overflowY: "auto", mt: 1 }}>
          {page.map((comp) => {
            return (
              <MenuItem
                key={comp["component-id"]}
                onClick={() => {
                  setIsLoading(true);
                  onChange(comp).then((comp) => {
                    setIsLoading(false);
                    onClose();
                  });
                }}
              >
                {comp.name}
              </MenuItem>
            );
          })}
        </Box>
      </Box>
    </Popover>
  );
};
